import { Schema } from '@gitbook/slate';

import { INLINE_EXPRESSION, LEAF_TEXT_BLOCKS } from '../types';

export const schema = Schema.create({
    inlines: {
        [INLINE_EXPRESSION]: {
            isVoid: true,
            parent: { types: LEAF_TEXT_BLOCKS },
            data: {
                expression: (expr) => typeof expr === 'string',
            },
        },
    },
});
